export const sortInAscendingOrder = (policies, sortField1, sortField2) => {
  return policies.sort((a, b) => {
    // If sortField1 has duplicates then sort that object with sortField2
    if (sortField2 && a[sortField1] === b[sortField1]) {
      return a[sortField2] > b[sortField2] ? 1 : -1;
    }
    return a[sortField1] > b[sortField1] ? 1 : -1;
  });
};
